import Vue from "vue"
import VueRouter from "vue-router"
import {auth, isLoggedIn, middlewarePipeline} from '@/middlewares';

import MainPage from "../views/MainPage"
import ConfirmationEmailPage from "../views/autch/ConfirmationEmailPage.vue"
import RestoreAccessPage from "../views/autch/RestoreAccessPage.vue"
import DebugPage from "../views/DebugPage.vue"
import ProfilePage from "../views/ProfilePage.vue"

import LoginPage from "@/views/autch/LoginPage";

import RegistrationPage from "@/views/autch/RegistrationPage";

// import PropsPage from "@/components/profile/ProfileCompany.vue";
import LocationsPage from "@/views/LocationsPage";
import ReportsPage from "@/views/ReportsPage";
// import ContractPage from "@/views/ContractPage";
import TicketsPage from "@/views/TicketsPage.vue";
import InboxPage from "@/views/InboxPage.vue";

Vue.use(VueRouter)

const routes = [

	//адреса используются при переходе из почты
	{ path: "/confirmation", name: "ConfirmationPage", meta: { middlewares: [] }, component: ConfirmationEmailPage },
	{ path: "/restore", name: "RestoreAccessPage", meta: { middlewares: []}, component: RestoreAccessPage },
	//=========================================
	{ path: "/login", name: "LoginPage", meta: { middlewares: [isLoggedIn] }, component: LoginPage },
	{ path: "/registration", name: "RegistrationPage", meta: {middlewares: [isLoggedIn] }, component: RegistrationPage },
	{ path: "/profile", name: "ProfilePage", meta:{ middlewares: [auth] }, component: ProfilePage }, //Сменить тему, язык, поменять пароль, выйти из аккаунта


	// { path: "/", name: "RootPage", component: MainPage },
	// { path: "/main", name: "MainPage", component: MainPage },
	{ path: "/", name: "RootPage",meta: { middlewares: [auth] }, component: MainPage },
	{ path: "/main", name: "MainPage",meta: { middlewares: [auth] }, component: MainPage },

	// { path: "/props", name: "MyPropsPage",meta: { middlewares: [auth] }, component: PropsPage },
	{ path: "/locations", name: "MyLocationsPage",meta: {middlewares: [auth] }, component: LocationsPage },
	{ path: "/reports", name: "MyReportsPage",meta: {middlewares: [auth] }, component: ReportsPage },

	{ path: "/tickets", name: "MyTicketsPage",meta: {middlewares: [auth] }, component: TicketsPage },
	// { path: "/tickets/:guid", name: "MyTicketsPage",meta: {middlewares: [auth] }, component: TicketsPage },
	{ path: "/inbox", name: "MyInboxPage",meta: {middlewares: [auth] }, component: InboxPage },
	// { path: "/inbox/:guid", name: "MyInboxPage",meta: {middlewares: [auth] }, component: InboxPage },

	// { path: "/contract", name: "ContractPage",meta: {middlewares: [auth] }, component: ContractPage },

	{ path: "/debug", name: "DebugPage", component: DebugPage },

	{ path: "*", component: { render: (h) => h("div", ["404! Page Not Found!"]) },},



]

const router = new VueRouter({
	mode: "history",
	base: process.env.BASE_URL,
	routes,
})


	router.beforeEach((to, from, next) => {
		const middlewares = to.meta.middlewares;
		if (!middlewares?.length) {
			return next();
		}
		// Запускаем обход по цепочке проверок
		const context = { to, from, next };
		const firstMiddlewareIndex = 0;
		const nextMiddlewareIndex = 1;
		return middlewares[firstMiddlewareIndex]({...context,
			nextMiddleware: middlewarePipeline(
				context,
				middlewares,
				nextMiddlewareIndex)});
	});


export default router
